import { useDispatch } from 'react-redux'
import { SET_UTILITIES } from '../features/State Management/utilitiesSlice'
import { SET_QUESTIONS } from '../features/State Management/questionsSlice'
import { resetAll } from '../features/State Management/questionSlice'
import { CLEAR_METADATA } from '../features/State Management/questionnaireMetadataSlice'
import { INITIAL_QUESTIONNAIRE_CONTEXT } from '../utils'

// Resets the local store as if it was the first time the user was visiting the
// site
export const useNewQuestionnaire = () => {
  const dispatch = useDispatch()

  return () => {
    dispatch(
      SET_UTILITIES({
        showsMap: {},
        hidesMap: {},
        saved: {},
      })
    )
    dispatch(SET_QUESTIONS({ questions: INITIAL_QUESTIONNAIRE_CONTEXT }))
    dispatch(resetAll())
    dispatch(CLEAR_METADATA())
  }
}
